import React, { useState } from 'react';
import ActionsDropdownAsync from './async';
import type { VisibleActions } from './types';

type Props = {
	isVisible: boolean;
	fieldId: string;
	fieldType: string;
	visibleActions: VisibleActions;
};

const ActionsDropdownMenu = ({ isVisible, ...rest }: Props) => {
	const [isMenuOpen, setMenuOpen] = useState(false);

	// Defer loading ActionsDropdownMenu until the column is hovered
	return isMenuOpen || isVisible ? (
		<ActionsDropdownAsync {...rest} setMenuOpen={setMenuOpen} />
	) : null;
};

export default ActionsDropdownMenu;
